import type { EventMediaType } from '@proaxiv/server-api'

/**
 * Derives the EP-14 MediaType from a MIME type, matching backend
 * {@code EventMediaService.deriveMediaType}. Returns null when unsupported.
 */
export function mediaTypeFromMime(mimeType: string | null | undefined): EventMediaType | null {
  if (!mimeType) return null
  if (mimeType.startsWith('image/')) return 'PHOTO'
  if (mimeType.startsWith('video/')) return 'VIDEO'
  if (mimeType.startsWith('audio/')) return 'AUDIO'
  if (mimeType === 'application/pdf') return 'PDF'
  return null
}

/** Client-side upload size cap (bytes) — server enforces the same 25 MB limit. */
export const MAX_EVENT_MEDIA_BYTES = 25 * 1024 * 1024
